// extracted by mini-css-extract-plugin
export default {"container":"_container_rOWSy","content":"_content_N3h5z","title":"_title_c2hc5"};